
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.375 5.688h.875c.963 0 1.75.73 1.75 1.625v8.125c0 .893-.787 1.624-1.75 1.624H1.75c-.963 0-1.75-.73-1.75-1.625V7.313c0-.894.787-1.625 1.75-1.625h.875V4.063C2.625 1.82 4.585 0 7 0s4.375 1.82 4.375 4.063v1.625zM7 1.625c-1.452 0-2.625 1.089-2.625 2.438v1.625h5.25V4.063c0-1.35-1.172-2.438-2.625-2.438zM1.75 15.437V7.312h10.5v8.125H1.75zm7-4.062c0 2.188-.787 2.188-1.75 2.188s-1.75 0-1.75-2.188S6.037 9.187 7 9.187s1.75 0 1.75 2.188z","fill":"#fff"}})])
          )
        }
      }
    